import { render, staticRenderFns } from "./KoreanLiveCartNewNotLogin.vue?vue&type=template&id=040e20da&scoped=true"
import script from "./KoreanLiveCartNewNotLogin.vue?vue&type=script&lang=js"
export * from "./KoreanLiveCartNewNotLogin.vue?vue&type=script&lang=js"
import style0 from "./KoreanLiveCartNewNotLogin.vue?vue&type=style&index=0&id=040e20da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e20da",
  null
  
)

export default component.exports